import { Module } from '../Module';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { IActionResource } from './Resource';

/*
 * This is the resource in vizportal's webclient api.
 * It is different than the resource, `Metrics.ts`, which is in the Metrics rest api on aws.
 */
export class MetricsResource {

  public static $inject = [
    '$q',
    'ErrorNotifyingServer'
  ];

  constructor(
    private $q: ng.IQService,
  ) { }
}

Module.instance().service('MetricsResource', MetricsResource);
